export default function gridBuilder () {

  $('body').on('click', '.wpgb-facet-title', function() {
    if( $(this).next().is(':visible')){
      $(this).next().slideUp('slow');
      $(this).next().parent().addClass('closed');
    } else {
      $(this).next().parent().removeClass('closed');
      $(this).next().slideDown('slow');
    }
  });

  function adjustViewportHeight(observer) {
    const sidebarHeight = $('.store-locator-grid .wpgb-sidebar-right').height();
    if (sidebarHeight && sidebarHeight > 178) {
      $('.store-locator-grid .wpgb-viewport').height(sidebarHeight - 178);
      observer.disconnect();
    }
  }

  function observeStoreLocator() {
    const target = document.querySelector('.store-locator-grid');
    if (!target) return;

    const observer = new MutationObserver(() => {
      adjustViewportHeight(observer);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    adjustViewportHeight(observer);
  }

  $(window).on('load resize', observeStoreLocator);

}